
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!

import { GenIceSector } from './GenIceSector';
import { GenMetricSource } from './GenMetricSource';

export class GenIceCountySummary {

    id: number;
    annualCustomerCost: number;
    annualCustomerCostRank: number;
    costPerCustomerEvent: number;
    costPerCustomerEventRank: number;
    costPerCustomerKw: number;
    costPerCustomerKwRank: number;
    costPerCustomerKwh: number;
    costPerCustomerKwhRank: number;
    costPerCustomerMin: number;
    costPerCustomerMinRank: number;
    costPerEvent: number;
    costPerEventRank: number;
    customerAffectedRank: number;
    customersAffected: number;
    customersAffectedPerEvent: number;
    customersAffectedPerEventRank: number;
    eventCount: number;
    fipsCode: string;
    name: string;
    sector: GenIceSector;
    source: GenMetricSource;
    stateAbbreviation: string;
    totalCost: number;
    totalCostRank: number;
    year: number;
    yearList: string;

    constructor();
    constructor( jsonObj: any );
    constructor( genIceCountySummary: GenIceCountySummary);
    constructor( id: number );

    constructor( input?: GenIceCountySummary|number ) {
        if ( typeof input === 'number') {
            this.id = input;
        }

        if ( input && typeof input !== 'number' ) {
            this.id = input.id; // int [number]
            this.annualCustomerCost = input.annualCustomerCost; // float [number]
            this.annualCustomerCostRank = input.annualCustomerCostRank; // int [number]
            this.costPerCustomerEvent = input.costPerCustomerEvent; // float [number]
            this.costPerCustomerEventRank = input.costPerCustomerEventRank; // int [number]
            this.costPerCustomerKw = input.costPerCustomerKw; // float [number]
            this.costPerCustomerKwRank = input.costPerCustomerKwRank; // int [number]
            this.costPerCustomerKwh = input.costPerCustomerKwh; // float [number]
            this.costPerCustomerKwhRank = input.costPerCustomerKwhRank; // int [number]
            this.costPerCustomerMin = input.costPerCustomerMin; // float [number]
            this.costPerCustomerMinRank = input.costPerCustomerMinRank; // int [number]
            this.costPerEvent = input.costPerEvent; // float [number]
            this.costPerEventRank = input.costPerEventRank; // int [number]
            this.customerAffectedRank = input.customerAffectedRank; // int [number]
            this.customersAffected = input.customersAffected; // float [number]
            this.customersAffectedPerEvent = input.customersAffectedPerEvent; // float [number]
            this.customersAffectedPerEventRank = input.customersAffectedPerEventRank; // int [number]
            this.eventCount = input.eventCount; // int [number]
            this.fipsCode = input.fipsCode; // string [string]
            this.name = input.name; // string [string]
            this.sector = (typeof input.sector === 'string') ? GenIceSector.forName(<string> input.sector) : <any> input.sector; // GenIceSector
            this.source = (typeof input.source === 'string') ? GenMetricSource.forName(<string> input.source) : <any> input.source; // GenMetricSource
            this.stateAbbreviation = input.stateAbbreviation; // string [string]
            this.totalCost = input.totalCost; // float [number]
            this.totalCostRank = input.totalCostRank; // int [number]
            this.year = input.year; // int [number]
            this.yearList = input.yearList; // string [string]
       }
    }

    static jsonResponseToList(arr: any[]): GenIceCountySummary[] {
        if (arr && arr.map) {
          return arr.map(a => new GenIceCountySummary(a));
        } else {
          return [];
        }
    }
}

